import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updateReasonTodo = createAsyncThunk('updateReason', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `reasons/${data?.id}`,
            data: {
                "reason_name": data.reason_name,
                "status": data.status,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('token')
            }
        });

        // ✅ Return only serializable fields
        return res
    } catch (error) {
        return error?.response
    }
});
